import { action, computed, observable, makeAutoObservable } from 'mobx';
import { FormInputState, FormModel } from 'src_common/common/mobx-utils/Form';
import React from 'react';

export class TextareaState {
    @observable isFocus: boolean = false;

    constructor(
        private readonly inputState: FormInputState<string>,
        private readonly inputModel: FormModel<string>
    ) {
        makeAutoObservable(this);
    }

    @action handleFocus = (): void => {
        this.isFocus = true;
    };

    @action handleBlur = (): void => {
        this.isFocus = false;
        this.inputState.setAsVisited();
    };

    @action handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        const value = event.currentTarget.value;

        this.inputState.setValue(value);
        this.inputState.setAsVisited();
    };

    @action handleChangeCKEditor = (value: string): void => {
        this.inputState.setValue(value);
        this.inputState.setAsVisited();
    };

    @computed get value(): string {
        return this.inputState.value;
    }

    @computed get isEmpty(): boolean {
        return this.inputState.value.length === 0;
    }

    @computed get errorMessage(): string | null {
        return this.inputModel.errorMessage;
    }
}
